import {get, post, get_1} from "../APIGateWay";


export async function getOnlineTesting(params = {}) {
    return await get_1(params,  process.env.VUE_APP_OT_URL)
}
export async function getOnlineTestingV2(params = {}) {
    return await get_1(params,  process.env.VUE_APP_OTV2_URL)
}
export async function getTutorings(params = {}) {
    return await get(params, '/tutoring/list')
}
export async function getTutoringsInComming(params = {}) {
    params.hours = params.hours || 5
    return await get(params, '/tutoring/class-upcomming')
}
export async function getClassess(params = {}) {
    return await get(params, '/live_class/list')
}

export async function tutoringSubscribe(data) {
    return await post(data, '/tutoring/subscribe')
}

export async function joinClass(params = {}) {
    return await get(params, '/tutoring/join')
}